
import { email, helpers, required } from '@vuelidate/validators';
import { computed, ComputedRef } from 'vue';


type ValidatorRule = { [key: string]: any; };
type CustomRule = (value: any, t: any) => string;
type FormData = Record<string, any>;
type ValidationRulesMap = Record<string, ((value: any) => any) | CustomRule>;

// =======================
// VUELIDATOR RULES
// =======================
export const requiredRule = (t: any): ValidatorRule => ({
    required: helpers.withMessage(t('form_validation.required_field'), required),
});

export const emailRule = (t: any): ValidatorRule => ({
    required: helpers.withMessage(t('form_validation.required_field'), required),
    email: helpers.withMessage(t('form_validation.invalid_email'), email),
});

export const isValidEmail = (t: any): ValidatorRule => ({
    isValidEmail: helpers.withMessage(t('form_validation.invalid_email'), email),
});

// =======================
// CUSTOM RULES
// =======================
export const requiredField: CustomRule = (value, t) => {
    return value ? '' : t('form_validation.required_field');
};

export const emailField: CustomRule = (value, t) => {
    if (!value) return t('form_validation.required_field');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value) ? '' : t('form_validation.invalid_email');
};

// =======================
// USE VALIDATION COMPOSABLE
// =======================
export const useValidation = (
        formData: FormData,
    validationRules: ValidationRulesMap
): { errors: ComputedRef<Record<string, string>> } => {
    const errors = computed(() => {
        const errorMessages: Record<string, string> = {};

        Object.keys(validationRules).forEach((key) => {
            const ruleFn = validationRules[key];
            if (ruleFn && typeof ruleFn === 'function') {
                errorMessages[key] = ruleFn(formData[key], (key: string) => key); // fallback za t
            }
        });

        return errorMessages;
    });

    return { errors };
};